import type {
  SavedAddress,
  CreateAddressDto,
  UpdateAddressDto,
} from '@printtat/shared';
import { apiFetch, apiJson } from '@/lib/apiFetch';

export const addressApi = {
  async getAddresses(): Promise<SavedAddress[]> {
    return apiJson<SavedAddress[]>('/addresses');
  },

  async createAddress(dto: CreateAddressDto): Promise<SavedAddress> {
    return apiJson<SavedAddress>('/addresses', { method: 'POST', body: dto });
  },

  async updateAddress(id: string, dto: UpdateAddressDto): Promise<SavedAddress> {
    return apiJson<SavedAddress>(`/addresses/${id}`, {
      method: 'PUT',
      body: dto,
    });
  },

  async deleteAddress(id: string): Promise<void> {
    const res = await apiFetch(`/addresses/${id}`, { method: 'DELETE' });
    if (!res.ok) {
      const e = await res.json().catch(() => ({}));
      throw new Error(e.message || 'Failed to delete address');
    }
  },

  async setDefault(id: string): Promise<SavedAddress> {
    return apiJson<SavedAddress>(`/addresses/${id}/default`, { method: 'POST' });
  },
};
